export const VEHICLE_SERIES_DEFINITION_SLICE_NAME = 'vehicleSeriesDefinition';
